import { useNavigate } from "react-router-dom";
import { RefreshCw, TriangleAlert, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useSessionSwitcher } from "@/contexts/SessionSwitcherContext";
import { useGetNotificariRecalcul } from "@/hooks/api/query/useGetNotificariRecalcul";
import { useMarcheazaNotificareCitita } from "@/hooks/api/mutate/useMarcheazaNotificareCitita";
import {
  notificariNecitite,
  textMotivRecalcul,
} from "@/utils/notificariRecalculFormatting";
import type { NotificareRecalcul as Notificare } from "@/types/notificariRecalcul";

function NotificareRecalcul() {
  const navigate = useNavigate();
  const { createSession } = useSessionSwitcher();
  const { data } = useGetNotificariRecalcul();
  const { mutate: marcheaza, isPending } = useMarcheazaNotificareCitita();

  const deAfisat = notificariNecitite(data?.data);
  if (deAfisat.length === 0) return null;

  const notificare: Notificare = deAfisat[0];

  const handleRecalculeaza = async () => {
    marcheaza({ id: notificare.id, recalculat: true });
    const creata = await createSession();
    if (!creata) return;
    navigate(
      notificare.cui
        ? `/identificare-raportare?cui=${encodeURIComponent(notificare.cui)}`
        : "/identificare-raportare"
    );
  };

  return (
    <div
      data-testid="notificare-recalcul"
      className="mb-4 md:mb-6 flex flex-col md:flex-row md:items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 p-4"
    >
      <TriangleAlert className="h-5 w-5 shrink-0 text-amber-600" />
      <div className="flex-1">
        <p className="text-sm font-semibold text-amber-900">
          {notificare.denumire ?? notificare.cui ?? "Firma dumneavoastră"}
        </p>
        <p className="text-sm text-amber-800">
          {textMotivRecalcul(notificare.motiv)}
        </p>
        {deAfisat.length > 1 && (
          <p className="mt-1 text-xs text-amber-700">
            Încă {deAfisat.length - 1}{" "}
            {deAfisat.length - 1 === 1 ? "notificare" : "notificări"} de
            recalcul
          </p>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          onClick={handleRecalculeaza}
          disabled={isPending}
          data-testid="notificare-recalcul-actiune"
          className="gap-2"
        >
          <RefreshCw className="h-4 w-4" />
          Recalculează
        </Button>
        <Button
          size="sm"
          variant="ghost"
          onClick={() => marcheaza({ id: notificare.id })}
          disabled={isPending}
          data-testid="notificare-recalcul-inchide"
          aria-label="Marchează notificarea ca citită"
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}

export default NotificareRecalcul;
